import React from 'react';
import styled from 'styled-components';
import Cta from '../../../atoms/CTA-CursorGradient/index';
import DynamicImage from '../../../atoms/DynamicImage';
import colors from '../../../../helpers/colors';

const Wrapper = styled.div`
    position: inherit;
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 140px 0 0 0;

    @media (max-width: 1250px) {
        max-width: none;
        padding: 140px 20px 0 20px;
    }

    @media (max-width: 769px) {
        padding: 51px 0 20px 0;
    }

    @media (max-width: 500px) {
        padding-top: 75px;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    align-items: center;

    @media (max-width: 1200px) {
        max-width: none;
        width: 100%;
        margin: 0 auto;
    }

    @media (max-width: 769px) {
        flex-direction: column;
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;

    @media (max-width: 900px) {
        width: 60%
    }

    @media (max-width: 769px) {
        padding: 52px 20px 0 20px;
        width: 100%;
        text-align: center;
    }

    @media (max-width: 500px) {
        padding: 30px 15px 0 15px;
    }
`;

const Title = styled.h1`
    font-size: 45px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    line-height: 1.5;
    width: 516px;

    @media (max-width: 900px) {
        width: 100%
    }

    @media (max-width: 769px) {
        text-align: center;
    }
    @media (max-width: 800px) {
        font-size: 35px;
    }
`;

const Description = styled.h3`
    font-size: 16px;
    font-weight: 300;
    color: ${colors.paragraphTextColor};
    line-height: 1.5;
    margin: 20px 0 50px 0;
    width: 510px;

    @media (max-width: 900px) {
        width: 100%
    }

    @media (max-width: 769px) {
        text-align: center;
    }
    @media (max-width: 500px) {
        margin-bottom: 0px;
    }
`;

const ImageContainer = styled.div`
    width: 600px;

    @media (max-width: 1200px) {
        width: 45%;
    }

    @media (max-width: 900px) {
        width: 40%;
    }

    @media (max-width: 769px) {
        width: 70%;
        padding-top: 80px;
        margin: 0 auto;
        height: 100%;
    }

    @media (max-width: 500px) {
        width: 90%;
        padding-top: 80px;
    }
`;


const CtaContainer = styled.div`
    width: 400px;

    @media (max-width: 769px) {
        margin: 0 auto; 
    }
    @media (max-width: 500px) {
        margin: 40px auto 0 auto;
        width: 100%;
    }
`;

const HeroSection = ({ heroImage }) => {
    return (   
        <Wrapper>
            <FlexContainer>
                <TextContainer>
                    <Title>Help build engaged teams — including ours.</Title>
                    <Description>
                        We think that life at work can <em>and should</em> be just as meaningful, satisfying, and enjoyable as life off the clock. 
                        That's why we are looking for people who are excited and talented to help take employee recognition to the next level!
                    </Description>

                    <CtaContainer>
                        <Cta ctaHref="#openPostions" ctaText="Apply Now" />
                    </CtaContainer>
                </TextContainer>

                <ImageContainer>
                    <DynamicImage src={heroImage} alt="Circle image of woman smiling, Carl the yeti pointing towards a man, and the man pointing back." />
                </ImageContainer>
            </FlexContainer>
        </Wrapper>
    );
};

export default HeroSection;
